import { Image } from "../Content/ContentStore";
import { ElementDataWatcher } from "../../Library/ElementDataWatcher";
import "./ImagesViewerElement.less";
import * as contentStyle from "./ContentViewers.less";

class ImagesViewerElement extends HTMLElement {
    private dataWatcher: ElementDataWatcher<Image[]>;

    connectedCallback() {
        this.dataWatcher = new ElementDataWatcher(this, "images");
        this.className += ` ${contentStyle.contentViewer}`;
        this.innerHTML = this.view(this.dataWatcher.data);
    }
    view = (images: Image[]) => `
        <h2>Images</h2>
        <div>
            ${images.map(image => this.imageView(image)).join("")}
        </div>
    `;

    private imageView = (image: Image) => `
        <div name=image>
            <div name=relation>${image.score} ${image.relation}</div>
            <a href="${image.url}" target=_blank>
                <img src="${image.url}" />
            </a>
            <div name=relation>${image.dimensions?.width || "?"} x ${image.dimensions?.height || "?"}</div>

        </div>
    `;
}

customElements.define("images-viewer", ImagesViewerElement);